import Papers from '../../assets/icons/papers.png'
import Book from '../../assets/icons/book.png'
import html2canvas from 'html2canvas'
import PersonCircle from '../../assets/icons/person_circle.png'
import Mail from '../../assets/icons/email.png'
import BoldIcon from '../../assets/icons/bold.svg'
import ItalicIcon from '../../assets/icons/italic.svg'
import OrderedListIcon from '../../assets/icons/ordered-list.svg'
import UnorderedListIcon from '../../assets/icons/unordered-list.svg'
import Phone from '../../assets/icons/phone.png'
import { useDateFormatter } from '../../hooks/useDateFormatter'
import { useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min'
import DownloadIcon from '../../assets/icons/download-white.svg'
import { useSearchInstitution } from '../../hooks/Institution/useSearchInstitution'
import { PendingReport } from '../Pending'
import {
  Container,
  Information,
  ImageEyeSelected,
  EyeSelected,
  DataRow,
  LeftContent,
  RightContent,
  Separator,
  Icon,
  LabelAndValueWrapper,
  Label,
  PapersText,
  LabelAndContactContainer,
  ContactWrapper,
  IconAndLabelWrapper,
  Contact,
  ParameterDescription,
  ParametersWrapper,
  ParametersCell,
  ParameterTitle,
  SignatureWrapper,
  Signature,
  DigitalSignatureTitle,
  DigitalSignatureValue,
  ButtonsWrapper,
  Button,
  ButtonIcon,
  DigitalSignatureWrapper,
  ContactIcon,
  LabelAndDescriptionWrapper,
  Description,
  InfoContainer,
  ThirdRowContainer,
  Header,
  Title,
  SubTitle,
  TabsWrapper,
  SelectContainer,
  SelectWrapper,
  SelectLabel,
  SelectTemplate,
  Textarea,
  TextareaFooter,
  EditIconsWrapper,
  EditIcon,
  ReportData
} from './styles'
import { useRef, useEffect, useState } from 'react'
import { useOpenPDF } from '../../hooks/useOpenPDF'
import { pdfDisponible } from '../../utils/pdfDisponible'
import { useLocation } from 'react-router-dom'

const DATA = {
  referible: {
    false: 'No',
    true: 'Si'
  },
  grado_RD: {
    0: 'Ausencia de Retinopatía',
    1: 'RD no proliferativa Leve',
    2: 'RD no proliferativa Moderada',
    3: 'RD no proliferativa Severa',
    4: 'RD proliferativa'
  },
  sospecha_MD: {
    0: 'Baja',
    1: 'Moderada',
    2: 'Alta'
  },
  otras_patologias: {
    true: 'Si',
    false: 'No'
  }
}

const textOrDash = (value) => {
  if (value === null || value === undefined) return '-'
  const trimmed = typeof value === 'string' ? value.trim() : value
  if (trimmed === '') return '-'
  return trimmed
}

const buildDetailedReportText = (reportData) => {
  if (!reportData) return '-'

  const hasStructuredFields = [
    reportData.hallazgos_ojo_derecho,
    reportData.hallazgos_ojo_izquierdo,
    reportData.impresion_diagnostica,
    reportData.conducta_recomendaciones,
    reportData.accion_inmediata,
    reportData.patologia_concomitante_detalle
  ].some((value) => value !== null && value !== undefined && String(value).trim() !== '')

  if (!hasStructuredFields) {
    return textOrDash(reportData.texto_libre)
  }

  const patologiaDetalle = reportData.otras_patologias === true
    ? textOrDash(reportData.patologia_concomitante_detalle)
    : reportData.otras_patologias === false
      ? 'No'
      : '-'

  return [
    `HALLAZGOS OJO DERECHO:\n${textOrDash(reportData.hallazgos_ojo_derecho)}`,
    `HALLAZGOS OJO IZQUIERDO:\n${textOrDash(reportData.hallazgos_ojo_izquierdo)}`,
    `IMPRESIÓN DIAGNÓSTICA:\n${textOrDash(reportData.impresion_diagnostica)}`,
    `CONDUCTA / RECOMENDACIONES:\n${textOrDash(reportData.conducta_recomendaciones)}`,
    `ACCIÓN INMEDIATA RECOMENDADA:\n${textOrDash(reportData.accion_inmediata)}`,
    `PATOLOGÍAS CONCOMITANTES (DETALLE):\n${patologiaDetalle}`
  ].join('\n\n')
}

export function Data ({ newData, dataSetter, study, patientData, selectedData, setEmptyField }) {
  const { user } = useSelector(state => state)
  const { formatDate } = useDateFormatter()
  const history = useHistory()
  const printRef = useRef(null)
  const { institution, getInstitution } = useSearchInstitution()
  const { openPDF } = useOpenPDF()

  useEffect(() => {
    const fetchInstitutionByStudy = async () => {
      try {
        await getInstitution(study.idInstitucion)
      } catch (error) {
        console.error('Error al obtener la institucion:', error)
      }
    }

    if (study && study.idInstitucion) {
      fetchInstitutionByStudy()
    }
  }, [study])

  useEffect(() => {
    // console.log("Valor de IA: "+ study.resumen_DX_IA);
    if (user.role === 'ophthalmologist' && isNewReport) {
      if (study && study.resumen_DX_IA != null) {
        dataSetter({
          ...newData,
          grado_RD: study.resumen_DX_IA ? 2 : 0,
          referible: !!study.resumen_DX_IA
        })
      }
    }
  }, [study, dataSetter])

  const downloadPDF = async () => {
    if (!pdfDisponible(study)) return
    let studyId = null
    if (user.role === 'patient') {
      studyId = study.id
    } else if (user.role === 'ophthalmologist') {
      studyId = study.idEstudio || study.id
    }
    if (studyId) {
      await openPDF(`estudios/descargar/${studyId}`)
    }
  }

  const handleChangeData = (e) => {
    dataSetter({
      ...newData, [e.target.name]: e.target.value
    })
    if (e.target.name === 'texto_libre' && e.target.value.trim() === '') {
      setEmptyField(true)
    } else {
      setEmptyField(false)
    }
  }

  const location = useLocation()
  const currentPath = location.pathname

  const isNewReport = currentPath.includes('/new-report')
  const isReport = currentPath.includes('/report')

  // Función para normalizar los datos del informe según el rol del usuario
  const getReportData = () => {
    let reportData = null

    if (user.role === 'patient') {
      // Para pacientes, informes está directamente en study
      reportData = study && study.informes && study.informes.length > 0 ? study.informes[0] : null
    } else if (user.role === 'ophthalmologist') {
      // Para oftalmólogos, verificar múltiples estructuras de datos posibles
      if (study && study.informes && study.informes.length > 0) {
        reportData = study.informes[0]
      } else if (selectedData && selectedData.informes && selectedData.informes.length > 0) {
        reportData = selectedData.informes[0]
      } else if (study && study.referible !== undefined) {
        // Si los datos están aplanados a nivel de study
        reportData = {
          referible: study.referible,
          grado_RD: study.grado_RD,
          sospecha_MD: study.sospecha_MD,
          otras_patologias: study.otras_patologias,
          hallazgos_ojo_derecho: study.hallazgos_ojo_derecho,
          hallazgos_ojo_izquierdo: study.hallazgos_ojo_izquierdo,
          impresion_diagnostica: study.impresion_diagnostica,
          conducta_recomendaciones: study.conducta_recomendaciones,
          accion_inmediata: study.accion_inmediata,
          patologia_concomitante_detalle: study.patologia_concomitante_detalle,
          texto_libre: study.texto_libre
        }
      }
    }

    return reportData
  }

  const reportData = getReportData()

  return (
    <Container ref={printRef}>
      <TabsWrapper>
        <Header>
          <Title> Datos del estudio </Title>
        </Header>
      </TabsWrapper>
      <DataRow>
        <LeftContent>
          <Icon src={Papers} alt='papers' />
        </LeftContent>
        <RightContent>
          <LabelAndValueWrapper>
            <Label> Fecha de estudio </Label>
            <InfoContainer>
              <PapersText> {study && formatDate(study.fecha)} </PapersText>
            </InfoContainer>
          </LabelAndValueWrapper>

          <LabelAndValueWrapper>
            <Label> Provincia </Label>
            <InfoContainer>
              <PapersText> {patientData && patientData.provincia} </PapersText>
            </InfoContainer>
          </LabelAndValueWrapper>

          <LabelAndValueWrapper>
            <Label> Localidad </Label>
            <InfoContainer>
              <PapersText> {patientData && patientData.localidad} </PapersText>
            </InfoContainer>
          </LabelAndValueWrapper>

          <LabelAndValueWrapper>
            <Label> Calle </Label>
            <InfoContainer>
              <PapersText> {patientData && patientData.calle} </PapersText>
            </InfoContainer>
          </LabelAndValueWrapper>

          <LabelAndValueWrapper>
            <Label> Número </Label>
            <InfoContainer>
              <PapersText> {patientData && patientData.numero} </PapersText>
            </InfoContainer>
          </LabelAndValueWrapper>

          <LabelAndValueWrapper>
            <Label> Institución </Label>
            <InfoContainer>
              <PapersText> {institution && institution.nombre} </PapersText>
            </InfoContainer>
          </LabelAndValueWrapper>
        </RightContent>
      </DataRow>

      {user.role === 'technical' && <Separator />}

      {user.role === 'technical' &&
        <Information>

          <DataRow>
            <LeftContent>
              <Icon src={PersonCircle} alt='book' />
            </LeftContent>
            <RightContent>
              <LabelAndContactContainer>
                <Label> Datos de contacto </Label>

                <ContactWrapper>
                  <IconAndLabelWrapper>
                    <ContactIcon src={Mail} alt='mail' />
                    <Label> Mail </Label>
                  </IconAndLabelWrapper>

                  <Contact> {patientData && patientData.email} </Contact>
                </ContactWrapper>

                <ContactWrapper>
                  <IconAndLabelWrapper>
                    <ContactIcon src={Phone} alt='phone' />
                    <Label> Teléfono  </Label>
                  </IconAndLabelWrapper>

                  <Contact> {patientData && patientData.telefono} </Contact>
                </ContactWrapper>
              </LabelAndContactContainer>
            </RightContent>
          </DataRow>
        </Information>}

      {study && study.informacionAdicional && <Separator />}

      {study && study.informacionAdicional &&
        <DataRow>
          <LeftContent>
            <Icon src={Book} alt='person-circle' />
          </LeftContent>
          <RightContent>
            <ThirdRowContainer>
              <LabelAndDescriptionWrapper>
                <Label> Información adicional </Label>
                <Description>
                  {study && study.informacionAdicional}
                </Description>
              </LabelAndDescriptionWrapper>
            </ThirdRowContainer>
          </RightContent>
        </DataRow>}

      {(user.role === 'patient' || (user.role === 'ophthalmologist' && isReport)) &&
        (reportData
          ? (
            <ReportData>
              <Separator />
              {study && study.requiere_recaptura ? (
                <>
                  <Title style={{ color: '#FF9800', marginBottom: '16px' }}> Requiere nueva captura por calidad insuficiente </Title>
                  <LabelAndDescriptionWrapper>
                    <Label>Motivo y recomendaciones operativas:</Label>
                    <Description>{reportData.conducta_recomendaciones || '-'}</Description>
                  </LabelAndDescriptionWrapper>
                </>
              ) : (
                <>
                  <Title> Informe detallado del Retinólogo: </Title>

                  <ParametersWrapper>
                    <ParametersCell>
                      <ParameterTitle>Paciente referible a oftalmólogo/a</ParameterTitle>
                      <ParameterDescription>{DATA.referible[reportData.referible]}</ParameterDescription>
                    </ParametersCell>

                    <ParametersCell>
                      <ParameterTitle>Grado de RD observada</ParameterTitle>
                      <ParameterDescription>{DATA.grado_RD[reportData.grado_RD]}</ParameterDescription>
                    </ParametersCell>

                    <ParametersCell>
                      <ParameterTitle>Sospecha de Edema Macular Diabético</ParameterTitle>
                      <ParameterDescription>{DATA.sospecha_MD[reportData.sospecha_MD]}</ParameterDescription>
                    </ParametersCell>

                    <ParametersCell>
                      <ParameterTitle>Se observan otras patologías concomitantes?</ParameterTitle>
                      <ParameterDescription>{DATA.otras_patologias[reportData.otras_patologias]}</ParameterDescription>
                    </ParametersCell>
                  </ParametersWrapper>

                  <LabelAndDescriptionWrapper>
                    <Label>Informe profesional extendido:</Label>
                    <Description>{buildDetailedReportText(reportData)}</Description>
                  </LabelAndDescriptionWrapper>
                </>
              )}

              <ButtonsWrapper>
                <Button
                  type='primary'
                  disabled={!pdfDisponible(study)}
                  title={pdfDisponible(study) ? 'Descargar PDF' : 'Preparando PDF...'}
                  aria-label={pdfDisponible(study) ? 'Descargar PDF' : 'Preparando PDF...'}
                  onClick={downloadPDF}
                >
                  <ButtonIcon src={DownloadIcon} alt='download' />
                  Descargar PDF
                </Button>
              </ButtonsWrapper>
            </ReportData>
            )
          : (
            <PendingReport />
            ))}

      {user.role === 'ophthalmologist' && isNewReport && (
        <ReportData>
          <Separator />
          <SubTitle> Diagnostico: </SubTitle>

          <SelectContainer>
            <SelectWrapper>
              <SelectLabel> Paciente referible a oftalmólogo/a </SelectLabel>
              <SelectTemplate name='referible' value={newData.referible} onChange={handleChangeData}>
                <option value>Si</option>
                <option value={false}>No</option>
              </SelectTemplate>
            </SelectWrapper>

            <SelectWrapper>
              <SelectLabel> Grado de RD observada </SelectLabel>
              <SelectTemplate name='grado_RD' value={newData.grado_RD} onChange={handleChangeData}>
                <option value={0}>Ausencia de Retinopatía</option>
                <option value={1}>RD no proliferativa Leve</option>
                <option value={2}>RD no proliferativa Moderada</option>
                <option value={3}>RD no proliferativa Severa</option>
                <option value={4}>RD proliferativa</option>
              </SelectTemplate>
            </SelectWrapper>

            <SelectWrapper>
              <SelectLabel> Sospecha de Edema Macular Diabético </SelectLabel>
              <SelectTemplate name='sospecha_MD' value={newData.sospecha_MD} onChange={handleChangeData}>
                <option value={0}>Baja</option>
                <option value={1}>Moderada</option>
                <option value={2}>Alta</option>
              </SelectTemplate>
            </SelectWrapper>

            <SelectWrapper>
              <SelectLabel> Se observan otras patologías concomitantes? </SelectLabel>
              <SelectTemplate name='otras_patologias' value={newData.otras_patologias} onChange={handleChangeData}>
                <option value>Si</option>
                <option value={false}>No</option>
              </SelectTemplate>
            </SelectWrapper>
          </SelectContainer>
          <Separator />
          <SubTitle> Observaciones: </SubTitle>
          <Textarea name='texto_libre' value={newData.texto_libre} onChange={handleChangeData} rows='4' />
        </ReportData>
      )}
    </Container>

  )
}

export default Data
